import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.$scope.currentPromise = null;
        this.types = {3: this.gettext('SMS'), 4: this.gettext('Voice')};
        this.phones = null;
        this.setPhones();

        this.$element.on('$destroy', () => {
            this.UiHelper.closeModals();
        });
    }

    setPhones() {
        this.$scope.currentPromise = this.getPhoneNumbers().then(resp => {
            this.phones = resp.data;
            this.showEmptyMessage = this.phones.length === 0;
        });
    }

    _showUserCodeModal() {
        this.askUserCode()
            .then(userCode => {
                if (userCode) {
                    this.tryToSetPhone(userCode)
                }
            }).catch(() => {
        });
    }

    _showModal(modalName) {
        this.$scope.userCode = '';
        this.showModal(modalName);
    }

    _genericResponseHandle(func) {

        this.ModalDialogService.isModalClosed = false;

        this.$scope.currentPromise = func.then(() => {
            this.ModalDialogService.isModalClosed = true;
            this.popMessage(this.updateOKText);
        }).catch(err => {
            this.ModalDialogService.isModalClosed = true;
            this.popMessage(err.data.message, 'error');
            this.setPhones();
        }).finally();

    }

    _setPhone(userCode, phoneObject) {
        this._genericResponseHandle(this._PanelsService.changePanelPhone(this.panelId, phoneObject, userCode));
    }

    onEditAddPhone(phone, requestType = 'update') {
        this.requestType = requestType;
        this.currentPhoneObj = phone;
        this._showModal('editPhoneModal');
    }

    tryToSetPhone(userCode) {
        this._setPhone(userCode, this.currentPhoneObj);
    }

    onDisableEnablePhone(phone) {
        this.currentPhoneObj = phone;
        this._showUserCodeModal();
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/phones.component/controller.js
 **/